export const getAgencySmsLogsUrl = () => 'agency/sms_logs';

export const getAgencySmsLogUrl = (id: number | string) => `agency/sms_logs/${id}`;
